import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { appEvents } from 'modules';



export interface IProps {
  title: string;
  body: string;
}

export const FC: React.FC<IProps> = props => {



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  return (
    <Dialog
      open
      onClose={handleClose}>
      <DialogTitle>
        {props.title}
      </DialogTitle>

      <DialogContent>
        {props.body}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
